






















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Row } from '@/entities/simplelist'

@Component<SimpleList>({})
export default class SimpleList extends Vue {
    @Prop({ type: Array })
    public rows!: Row[]

    @Prop({ type: Boolean, required: false, default: true })
    public hasLeftGutter?: boolean

    private clickRow(row: Row) {
        if (row && row.onClick) {
            row.onClick!()
        }
    }
}
